import axios from 'axios'
import moment from 'moment'
import emojiStrip from 'emoji-strip'
import { i18n } from '@/i18n'

let BACKEND_URL = 'https://contents.geek9.kr'
let POCKETBASE_URL = 'http://34.64.121.6'
const SMART_STORE_URL = 'https://smartstore.naver.com/geek9/products/'
const CAFE_STORE_URL = 'https://cafe.naver.com/geek9/'

let WSRV_POCKETBASE_URL = '//wsrv.nl/?url=http://34.64.121.6:8090/api/files/'
let REDIRECT_URI = 'https://geek9.kr'

let axiosGeek9
if(window.location.hostname === 'localhost') {
  BACKEND_URL = 'http://localhost'
  REDIRECT_URI = BACKEND_URL + ':3000'
  BACKEND_URL = BACKEND_URL + ':4000'
  axiosGeek9 = axios.create({
    baseURL: BACKEND_URL
  })
} else if(window.location.hostname.indexOf('100.76') !== -1) {
  BACKEND_URL = 'http://100.76.102.15'
  REDIRECT_URI = BACKEND_URL + ':3000'
  BACKEND_URL = BACKEND_URL + ':4000'
  axiosGeek9 = axios.create({
    baseURL: BACKEND_URL
  })
} else {
  axiosGeek9 = axios.create({
    baseURL: BACKEND_URL
  })
}

let FORWARDER = new Map()

const FINANCE_PRICE1 = "해외직구>매입"
const FINANCE_PRICE2 = "해외직구>판매"
const FINANCE_PRICE3 = "해외직구>국내배대지"
const FINANCE_PRICE4 = "해외직구>해외배송비"
const FINANCE_OUTCOME = "지출"
const FINANCE_INCOME = "수입"

const CAFE_MENU_LIST = 
  [
    {name:"여성패션", id:"100"},
    {name:"남성패션", id:"101"},
    {name:"유니폼", id:"102"},
    {name:"장난감", id:"103"},
    {name:"신발", id:"104"},
    {name:"등산", id:"106"},
    {name:"주얼리", id:"107"},
    {name:"기타", id:"105"}
  ]

const ETC_COUNTRIES = [
  { name: `${i18n.global.t('country.KR')}`, code: 'KR', phone: '82', currency: 'WON' },
]

// 싱가포르는 대만 말레이시아 미국 베트남 일본 태국으로만 배송 가능
const REV_COUNTRIES = [
  { name: `${i18n.global.t('country.US')}`, code: 'US', phone: '1', currency: 'USD' },
  { name: `${i18n.global.t('country.HK')}`, code: 'HK', phone: '852', currency: 'HKD' },
  { name: `${i18n.global.t('country.SG')}`, code: 'SG', phone: '65', currency: 'SGD' },
  { name: `${i18n.global.t('country.MY')}`, code: 'MY', phone: '60', currency: 'MYR' },
  { name: `${i18n.global.t('country.AU')}`, code: 'AU', phone: '61', currency: 'AUD' },
  { name: `${i18n.global.t('country.JP')}`, code: 'JP', phone: '81', currency: 'JPY' },
  ...ETC_COUNTRIES
]

// const SRC_COUNTRIES = [
//   { name: `${i18n.global.t('country.KR')}`, code: 'KR', phone: '82', currency: 'WON' },
//   { name: `${i18n.global.t('country.HK')}`, code: 'HK', phone: '852', currency: 'HKD' },
//   { name: `${i18n.global.t('country.SG')}`, code: 'SG', phone: '65', currency: 'SGD' },
//   { name: `${i18n.global.t('country.MY')}`, code: 'MY', phone: '60', currency: 'MYR' },
// ]

const DELIVERY_COUNTRIES = [
  { name: `${i18n.global.t('country.CN')}`, code: 'CN', phone: '86', currency: 'CNY' },
  { name: `${i18n.global.t('country.FR')}`, code: 'FR', phone: '33', currency: 'EUR' },
  { name: `${i18n.global.t('country.DE')}`, code: 'DE', phone: '49', currency: 'EUR' },
  { name: `${i18n.global.t('country.JP')}`, code: 'JP', phone: '81', currency: 'JPY' },
  { name: `${i18n.global.t('country.ES')}`, code: 'ES', phone: '34', currency: 'EUR' },
  { name: `${i18n.global.t('country.DK')}`, code: 'DK', phone: '45', currency: 'DKK' },
  { name: `${i18n.global.t('country.US')}`, code: 'US', phone: '1', currency: 'USD' },
  { name: `${i18n.global.t('country.HK')}`, code: 'HK', phone: '852', currency: 'HKD' },
  { name: `${i18n.global.t('country.NL')}`, code: 'NL', phone: '31', currency: 'EUR' },
  { name: `${i18n.global.t('country.MY')}`, code: 'MY', phone: '60', currency: 'MYR' },
  { name: `${i18n.global.t('country.IT')}`, code: 'IT', phone: '39', currency: 'EUR' },
  { name: `${i18n.global.t('country.GB')}`, code: 'GB', phone: '44', currency: 'GBP' },
  { name: `${i18n.global.t('country.AU')}`, code: 'AU', phone: '61', currency: 'AUD' },
  { name: `${i18n.global.t('country.SE')}`, code: 'SE', phone: '46', currency: 'SEK' },
  { name: `${i18n.global.t('country.AT')}`, code: 'AT', phone: '43', currency: 'EUR' },
  { name: `${i18n.global.t('country.TW')}`, code: 'TW', phone: '886', currency: 'TWD' },
  { name: `${i18n.global.t('country.NZ')}`, code: 'NZ', phone: '64', currency: 'NZD' }
]

const BUY_COUNTRIES = [
  { name: `${i18n.global.t('country.SG')}`, code: 'SG', phone: '65', currency: 'SGD' },
  { name: `${i18n.global.t('country.IS')}`, code: 'IS', phone: '354', currency: 'ISK' },
  { name: `${i18n.global.t('country.PL')}`, code: 'PL', phone: '48', currency: 'PLN' },
  { name: `${i18n.global.t('country.HU')}`, code: 'HU', phone: '36', currency: 'HUF' },
  { name: `${i18n.global.t('country.GR')}`, code: 'GR', phone: '30', currency: 'EUR' },
  { name: `${i18n.global.t('country.BR')}`, code: 'BR', phone: '55', currency: 'BRL' },
  { name: `${i18n.global.t('country.TH')}`, code: 'TH', phone: '66', currency: 'THB' },
  { name: `${i18n.global.t('country.PH')}`, code: 'PH', phone: '63', currency: 'PHP' },
  { name: `${i18n.global.t('country.PT')}`, code: 'PT', phone: '351', currency: 'EUR' },
  { name: `${i18n.global.t('country.FI')}`, code: 'FI', phone: '358', currency: 'EUR' },
  { name: `${i18n.global.t('country.CZ')}`, code: 'CZ', phone: '420', currency: 'CZK' },
  { name: `${i18n.global.t('country.VN')}`, code: 'VN', phone: '84', currency: 'VND' },
  { name: `${i18n.global.t('country.SK')}`, code: 'SK', phone: '421', currency: 'EUR' },
  { name: `${i18n.global.t('country.MX')}`, code: 'MX', phone: '52', currency: 'MXN' },
  { name: `${i18n.global.t('country.IL')}`, code: 'IL', phone: '972', currency: 'ILS' },
  { name: `${i18n.global.t('country.KZ')}`, code: 'KZ', phone: '7', currency: 'KZT' },
  { name: `${i18n.global.t('country.ID')}`, code: 'ID', phone: '62', currency: 'IDR' },
  { name: `${i18n.global.t('country.EE')}`, code: 'EE', phone: '372', currency: 'EUR' },
  { name: `${i18n.global.t('country.LV')}`, code: 'LV', phone: '371', currency: 'EUR' },
  { name: `${i18n.global.t('country.TR')}`, code: 'TR', phone: '90', currency: 'TRY' },
  { name: `${i18n.global.t('country.ZA')}`, code: 'ZA', phone: '27', currency: 'ZAR' },
  { name: `${i18n.global.t('country.LT')}`, code: 'LT', phone: '370', currency: 'EUR' },
  { name: `${i18n.global.t('country.IE')}`, code: 'IE', phone: '353', currency: 'EUR' },
  { name: `${i18n.global.t('country.IN')}`, code: 'IN', phone: '91', currency: 'INR' },
  { name: `${i18n.global.t('country.RO')}`, code: 'RO', phone: '40', currency: 'RON' },
  { name: `${i18n.global.t('country.SI')}`, code: 'SI', phone: '386', currency: 'EUR' },
  { name: `${i18n.global.t('country.HR')}`, code: 'HR', phone: '385', currency: 'EUR' },
  { name: `${i18n.global.t('country.CY')}`, code: 'CY', phone: '357', currency: 'EUR' },
  { name: `${i18n.global.t('country.UA')}`, code: 'UA', phone: '380', currency: 'UAH' },
  { name: `${i18n.global.t('country.RU')}`, code: 'RU', phone: '7', currency: 'RUB' },
  { name: `${i18n.global.t('country.NO')}`, code: 'NO', phone: '47', currency: 'NOK' },
  { name: `${i18n.global.t('country.RS')}`, code: 'RS', phone: '381', currency: 'RSD' },
  { name: `${i18n.global.t('country.JO')}`, code: 'JO', phone: '962', currency: 'JOD' },
  { name: `${i18n.global.t('country.CH')}`, code: 'CH', phone: '41', currency: 'CHF' },
  { name: `${i18n.global.t('country.MO')}`, code: 'MO', phone: '853', currency: 'MOP' },
  { name: `${i18n.global.t('country.AE')}`, code: 'AE', phone: '971', currency: 'AED' },
  { name: `${i18n.global.t('country.CA')}`, code: 'CA', phone: '1', currency: 'CAD' },
  { name: `${i18n.global.t('country.SA')}`, code: 'SA', phone: '966', currency: 'SAR' },
  { name: `${i18n.global.t('country.QA')}`, code: 'QA', phone: '974', currency: 'QAR' },
  { name: `${i18n.global.t('country.GL')}`, code: 'GL', phone: '299', currency: 'DKK' },
  { name: `${i18n.global.t('country.LU')}`, code: 'LU', phone: '352', currency: 'EUR' },
  { name: `${i18n.global.t('country.KW')}`, code: 'KW', phone: '965', currency: 'KWD' },
  { name: `${i18n.global.t('country.OM')}`, code: 'OM', phone: '968', currency: 'OMR' },
  { name: `${i18n.global.t('country.BH')}`, code: 'BH', phone: '973', currency: 'BHD' },
  { name: `${i18n.global.t('country.LB')}`, code: 'LB', phone: '961', currency: 'LBP' },
  { name: `${i18n.global.t('country.SY')}`, code: 'SY', phone: '963', currency: 'SYP' },
  { name: `${i18n.global.t('country.EG')}`, code: 'EG', phone: '20', currency: 'EGP' },
  { name: `${i18n.global.t('country.NA')}`, code: 'NA', phone: '264', currency: 'NAD' },
  { name: `${i18n.global.t('country.LS')}`, code: 'LS', phone: '266', currency: 'LSL' },
  { name: `${i18n.global.t('country.SZ')}`, code: 'SZ', phone: '268', currency: 'SZL' },
  { name: `${i18n.global.t('country.NG')}`, code: 'NG', phone: '234', currency: 'NGN' },
  { name: `${i18n.global.t('country.KE')}`, code: 'KE', phone: '254', currency: 'KES' },
  { name: `${i18n.global.t('country.AR')}`, code: 'AR', phone: '54', currency: 'ARS' },
  { name: `${i18n.global.t('country.CL')}`, code: 'CL', phone: '56', currency: 'CLP' },
]

const COUNTRIES = [...DELIVERY_COUNTRIES, ...BUY_COUNTRIES, ...ETC_COUNTRIES]

const getCountryName = (param) => {
  const country = param.country
  
  if (country === `${i18n.global.t('country.LU')}`) return '룩셈부르크'
  if (country === `${i18n.global.t('country.KR')}`) return '한국'
  if (country === `${i18n.global.t('country.US')}`) return '미국'
  if (country === `${i18n.global.t('country.HK')}`) return '홍콩'
  if (country === `${i18n.global.t('country.SG')}`) return '싱가포르'
  if (country === `${i18n.global.t('country.MY')}`) return '말레이시아'
  if (country === `${i18n.global.t('country.AU')}`) return '호주'
  if (country === `${i18n.global.t('country.JP')}`) return '일본'
  if (country === `${i18n.global.t('country.CN')}`) return '중국'
  if (country === `${i18n.global.t('country.FR')}`) return '프랑스'
  if (country === `${i18n.global.t('country.DE')}`) return '독일'
  if (country === `${i18n.global.t('country.ES')}`) return '스페인'
  if (country === `${i18n.global.t('country.IT')}`) return '이탈리아'
  if (country === `${i18n.global.t('country.GB')}`) return '영국'
  if (country === `${i18n.global.t('country.NL')}`) return '네덜란드'
  if (country === `${i18n.global.t('country.SE')}`) return '스웨덴'
  if (country === `${i18n.global.t('country.AT')}`) return '오스트리아'
  if (country === `${i18n.global.t('country.TW')}`) return '대만'
  if (country === `${i18n.global.t('country.NZ')}`) return '뉴질랜드'
  if (country === `${i18n.global.t('country.IS')}`) return '아이슬란드'
  if (country === `${i18n.global.t('country.PL')}`) return '폴란드'
  if (country === `${i18n.global.t('country.HU')}`) return '헝가리'
  if (country === `${i18n.global.t('country.GR')}`) return '그리스'
  if (country === `${i18n.global.t('country.BR')}`) return '브라질'
  if (country === `${i18n.global.t('country.TH')}`) return '태국'
  if (country === `${i18n.global.t('country.PH')}`) return '필리핀'
  if (country === `${i18n.global.t('country.PT')}`) return '포르투갈'
  if (country === `${i18n.global.t('country.DK')}`) return '덴마크'
  if (country === `${i18n.global.t('country.FI')}`) return '핀란드'
  if (country === `${i18n.global.t('country.CZ')}`) return '체코'
  if (country === `${i18n.global.t('country.VN')}`) return '베트남'
  if (country === `${i18n.global.t('country.SK')}`) return '슬로바키아'
  if (country === `${i18n.global.t('country.MX')}`) return '멕시코'
  if (country === `${i18n.global.t('country.IL')}`) return '이스라엘'
  if (country === `${i18n.global.t('country.KZ')}`) return '카자흐스탄'
  if (country === `${i18n.global.t('country.ID')}`) return '인도네시아'
  if (country === `${i18n.global.t('country.EE')}`) return '에스토니아'
  if (country === `${i18n.global.t('country.LV')}`) return '라트비아'
  if (country === `${i18n.global.t('country.TR')}`) return '튀르키예'
  if (country === `${i18n.global.t('country.ZA')}`) return '남아프리카공화국'
  if (country === `${i18n.global.t('country.LT')}`) return '리투아니아'
  if (country === `${i18n.global.t('country.IE')}`) return '아일랜드'
  if (country === `${i18n.global.t('country.IN')}`) return '인도'
  if (country === `${i18n.global.t('country.RO')}`) return '루마니아'
  if (country === `${i18n.global.t('country.SI')}`) return '슬로베니아'
  if (country === `${i18n.global.t('country.HR')}`) return '크로아티아'
  if (country === `${i18n.global.t('country.CY')}`) return '키프로스'
  if (country === `${i18n.global.t('country.UA')}`) return '우크라이나'
  if (country === `${i18n.global.t('country.RU')}`) return '러시아'
  if (country === `${i18n.global.t('country.NO')}`) return '노르웨이'
  if (country === `${i18n.global.t('country.RS')}`) return '세르비아'
  if (country === `${i18n.global.t('country.JO')}`) return '요르단'
  if (country === `${i18n.global.t('country.CH')}`) return '스위스'
  if (country === `${i18n.global.t('country.MO')}`) return '마카오'
  if (country === `${i18n.global.t('country.AE')}`) return '아랍에미리트'
  if (country === `${i18n.global.t('country.CA')}`) return '캐나다'
  if (country === `${i18n.global.t('country.SA')}`) return '사우디아라비아'
  if (country === `${i18n.global.t('country.QA')}`) return '카타르'
  if (country === `${i18n.global.t('country.GL')}`) return '그린란드'
  
  if (country === `${i18n.global.t('country.KW')}`) return '쿠웨이트'
  if (country === `${i18n.global.t('country.OM')}`) return '오만'
  if (country === `${i18n.global.t('country.BH')}`) return '바레인'
  if (country === `${i18n.global.t('country.LB')}`) return '레바논'
  if (country === `${i18n.global.t('country.SY')}`) return '시리아'
  if (country === `${i18n.global.t('country.EG')}`) return '이집트'
  if (country === `${i18n.global.t('country.NA')}`) return '나미비아'
  if (country === `${i18n.global.t('country.LS')}`) return '레소토'
  if (country === `${i18n.global.t('country.SZ')}`) return '에스와티니'
  if (country === `${i18n.global.t('country.NG')}`) return '나이지리아'
  if (country === `${i18n.global.t('country.KE')}`) return '케냐'
  if (country === `${i18n.global.t('country.AR')}`) return '아르헨티나'
  if (country === `${i18n.global.t('country.CL')}`) return '칠레'

  if (country === '룩셈부르크') return `${i18n.global.t('country.LU')}`
  if (country === '한국') return `${i18n.global.t('country.KR')}`
  if (country === '미국') return `${i18n.global.t('country.US')}`
  if (country === '홍콩') return `${i18n.global.t('country.HK')}`
  if (country === '싱가포르') return `${i18n.global.t('country.SG')}`
  if (country === '말레이시아') return `${i18n.global.t('country.MY')}`
  if (country === '호주') return `${i18n.global.t('country.AU')}`
  if (country === '일본') return `${i18n.global.t('country.JP')}`
  if (country === '중국') return `${i18n.global.t('country.CN')}`
  if (country === '프랑스') return `${i18n.global.t('country.FR')}`
  if (country === '독일') return `${i18n.global.t('country.DE')}`
  if (country === '스페인') return `${i18n.global.t('country.ES')}`
  if (country === '이탈리아') return `${i18n.global.t('country.IT')}`
  if (country === '영국') return `${i18n.global.t('country.GB')}`
  if (country === '네덜란드') return `${i18n.global.t('country.NL')}`
  if (country === '스웨덴') return `${i18n.global.t('country.SE')}`
  if (country === '오스트리아') return `${i18n.global.t('country.AT')}`
  if (country === '대만') return `${i18n.global.t('country.TW')}`
  if (country === '뉴질랜드') return `${i18n.global.t('country.NZ')}`
  if (country === '아이슬란드') return `${i18n.global.t('country.IS')}`
  if (country === '폴란드') return `${i18n.global.t('country.PL')}`
  if (country === '헝가리') return `${i18n.global.t('country.HU')}`
  if (country === '그리스') return `${i18n.global.t('country.GR')}`
  if (country === '브라질') return `${i18n.global.t('country.BR')}`
  if (country === '태국') return `${i18n.global.t('country.TH')}`
  if (country === '필리핀') return `${i18n.global.t('country.PH')}`
  if (country === '포르투갈') return `${i18n.global.t('country.PT')}`
  if (country === '덴마크') return `${i18n.global.t('country.DK')}`
  if (country === '핀란드') return `${i18n.global.t('country.FI')}`
  if (country === '체코') return `${i18n.global.t('country.CZ')}`
  if (country === '베트남') return `${i18n.global.t('country.VN')}`
  if (country === '슬로바키아') return `${i18n.global.t('country.SK')}`
  if (country === '멕시코') return `${i18n.global.t('country.MX')}`
  if (country === '이스라엘') return `${i18n.global.t('country.IL')}`
  if (country === '카자흐스탄') return `${i18n.global.t('country.KZ')}`
  if (country === '인도네시아') return `${i18n.global.t('country.ID')}`
  if (country === '에스토니아') return `${i18n.global.t('country.EE')}`
  if (country === '라트비아') return `${i18n.global.t('country.LV')}`
  if (country === '튀르키예') return `${i18n.global.t('country.TR')}`
  if (country === '남아프리카공화국') return `${i18n.global.t('country.ZA')}`
  if (country === '리투아니아') return `${i18n.global.t('country.LT')}`
  if (country === '아일랜드') return `${i18n.global.t('country.IE')}`
  if (country === '인도') return `${i18n.global.t('country.IN')}`
  if (country === '루마니아') return `${i18n.global.t('country.RO')}`
  if (country === '슬로베니아') return `${i18n.global.t('country.SI')}`
  if (country === '크로아티아') return `${i18n.global.t('country.HR')}`
  if (country === '키프로스') return `${i18n.global.t('country.CY')}`
  if (country === '우크라이나') return `${i18n.global.t('country.UA')}`
  if (country === '러시아') return `${i18n.global.t('country.RU')}`
  if (country === '노르웨이') return `${i18n.global.t('country.NO')}`
  if (country === '세르비아') return `${i18n.global.t('country.RS')}`
  if (country === '요르단') return `${i18n.global.t('country.JO')}`
  if (country === '스위스') return `${i18n.global.t('country.CH')}`
  if (country === '마카오') return `${i18n.global.t('country.MO')}`
  if (country === '아랍에미리트') return `${i18n.global.t('country.AE')}`
  if (country === '캐나다') return `${i18n.global.t('country.CA')}`
  if (country === '사우디아라비아') return `${i18n.global.t('country.SA')}`
  if (country === '카타르') return `${i18n.global.t('country.QA')}`
  if (country === '그린란드') return `${i18n.global.t('country.GL')}`
  if (country === '쿠웨이트') return `${i18n.global.t('country.KW')}`
  if (country === '오만') return `${i18n.global.t('country.OM')}`
  if (country === '바레인') return `${i18n.global.t('country.BH')}`
  if (country === '레바논') return `${i18n.global.t('country.LB')}`
  if (country === '시리아') return `${i18n.global.t('country.SY')}`
  if (country === '이집트') return `${i18n.global.t('country.EG')}`
  if (country === '나미비아') return `${i18n.global.t('country.NA')}`
  if (country === '레소토') return `${i18n.global.t('country.LS')}`
  if (country === '에스와티니') return `${i18n.global.t('country.SZ')}`
  if (country === '나이지리아') return `${i18n.global.t('country.NG')}`
  if (country === '케냐') return `${i18n.global.t('country.KE')}`
  if (country === '아르헨티나') return `${i18n.global.t('country.AR')}`
  if (country === '칠레') return `${i18n.global.t('country.CL')}`


  if (country === '기타') return `${i18n.global.t('menu.etc')}`
  
  
  
  return country
}

const getCateNameById = (id) => {
  const item = CAFE_MENU_LIST.find(menu => menu.id === id);
  return item ? item.name : null;
}

// const AWS = require('aws-sdk')
require('dotenv').config()
let request = require('request')

// AWS.config.region = 'ap-northeast-2'
// AWS.config.credentials = new AWS.CognitoIdentityCredentials({
//     IdentityPoolId: 'ap-northeast-2:53a1ff0b-4f33-4181-b416-a62e5d1a507d',
// })

// const s3 = new AWS.S3({
//   accessKeyId: process.env.S3_ACCESS_KEY_ID,
//   secretAccessKey: process.env.S3_SECRET_ACCESS_KEY, 
//   region: process.env.S3_REGION
// })

const getOAuthToken = async (code, state) => {
  try {
    const tokenResponse = await axios.post(
      "https://nid.naver.com/oauth2.0/token",
      null,
      {
        params: {
          grant_type: "authorization_code",
          client_id: process.env.VUE_APP_NAVER_CLIENT_ID,
          client_secret: process.env.VUE_APP_NAVER_SECRET_KEY,
          code: code,
          state: state
        }
      }
    )
    return tokenResponse.data.access_token
  } catch (error) {
    console.error("OAuth 토큰 발급 실패:", error.response?.data || error.message)
    throw error
  }
}

const stripHtmlTags = (html) => {
  return html.replace(/<[^>]*>/g, '')
}

const copyClipboard = (val) => {
  navigator.clipboard.writeText(val)
  .then( () => console.log(`${this.t('sentence.item37')} : ` + val)
  ).catch( (err) => console.log(err) )
}

const list2String = async (list) => {
  let result = ''
  for(let i=0; i<list.length; i++) {
    result += JSON.stringify(list[i])
    if(i !== list.length-1) result += ', '
  }
  return result
}

const resizeImage = (image, width) => {
  
  return new Promise( (resolve, reject) => {
    image.onload = async  function() {
      try {
        const originalWidth = image.width
        const originalHeight = image.height
        
        const aspectRatio = originalWidth / originalHeight
        
        const newWidth = width
        const newHeight = width / aspectRatio
        
        let canvas = document.createElement('canvas')
        let context = canvas.getContext('2d')
        
        canvas.width = newWidth
        canvas.height = newHeight
        
        context.drawImage(image, 0, 0, newWidth, newHeight)
        resolve(canvas.toDataURL('image/jpeg')) 
      } catch (err) {
        reject(err)
      }
    }
  })
}

const getGoogleTranslateUrl = (param) => {
  const country = param.country
  const desc = param.desc
  let sl = ''
  if(country === '프랑스' || country === getCountryName({country:'프랑스'})) sl = 'fr'
  else if(country === '스페인' || country === getCountryName({country:'스페인'})) sl = 'es'
  else if(country === '이탈리아' || country === getCountryName({country:'이탈리아'})) sl = 'it'
  else if(country === '홍콩' || country === getCountryName({country:'홍콩'})) sl = 'zh'
  else if(country === '네덜란드' || country === getCountryName({country:'네덜란드'})) sl = 'nl'
  return "https://translate.google.com/?sl=" + sl + "&tl=ko&text=" + desc
}

const requestFacebook = () => {
  return new Promise((resolve, reject) => {
    if (window.FB) {
      resolve({sdkReady:true})
      return
    }

    window.fbAsyncInit = function() {
      window.FB.init({
        appId : process.env.VUE_APP_FACEBOOK_APP_ID,
        xfbml : true,
        version : 'v21.0'
      })
      window.FB.AppEvents.logPageView()
      resolve({sdkReady:true})
    };

    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id
      js.src = "https://connect.facebook.net/en_US/sdk.js"
      fjs.parentNode.insertBefore(js, fjs);
      js.onerror = () => reject({sdkReady:false})
    }(document, 'script', 'facebook-jssdk'))
  })
}

const requestGoogle = async (param) =>{
  return new Promise( (resolve, reject) => {
    const code = param.code
    axios.post(
      'https://oauth2.googleapis.com/token',
      {
        code: code,
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        client_secret: process.env.VUE_APP_GOOGLE_CLIENT_SECRET,
        // redirect_uri: 'http://localhost:3000/login/oauth2/code/google',
        redirect_uri: REDIRECT_URI,
        grant_type: 'authorization_code',
      },
    ).then( async (res) => {
      const accessToken = res.data.access_token
      if(accessToken) {
        await axios.get(
          'https://www.googleapis.com/oauth2/v3/userinfo',
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        ).then( async (res2) => {
          resolve(res2)
        })
      } else reject(undefined)
    })
    .catch( (err) => {
      console.log(err)
      reject(err)
    })
  })
}

const translate = (source, target, query) => {
  const options = {
    url: 'https://api-free.deepl.com/v2/translate',
    form: {'target_lang':target, 'text':query},
    headers: {'Authorization':process.env.DEEPL_KEY}
    // url: 'https://openapi.naver.com/v1/papago/n2mt',
    // form: {'source':source, 'target':target, 'text':query},
    // headers: {'X-Naver-Client-Id':process.env.PAPAGO_CLIENT_ID, 'X-Naver-Client-Secret': process.env.PAPAGO_CLIENT_SECRET, 'Content-Type':'application/json'}
  }

  return new Promise( (resolve, reject) => {
    request.post(options, function (error, response, body) {
      if (!error && response.statusCode == 200) {
        resolve(body)
      } else {
        reject('error = ' + response.statusCode)
        console.log('error = ' + response.statusCode)
      }
    }) 
  })
}

// window.location.hostname === 'localhost' ? 
// axios.defaults.baseURL = 'http://localhost:4000' : 
// axios.defaults.baseURL = GCP_URL :            // GCP 
// axios.defaults.baseURL = HR4U_PC_URL + ':4000' :     // HR4U

// axios.defaults.baseURL = 'https://graphql.geek9.kr'
// axios.defaults.baseURL = GCP_URL

const getCookies = (key) => {
  return window.$cookies.get(key)
}

const setCookies = (key, value) => {
  window.$cookies.set(key, value)
}

const setPage = (page) => {
  setCookies('page', page)
}

const clear_cache = () => {
  window.$cookies.clear()
}

const validate = (type, target) => {
  let value
  if(type === 'phone') {
    value =  target.value
    value = value.replace(/[^0-9]/g, '')
    target.value = value
  } else if(type === 'email') {
    value =  target.value
    let reg = /^[0-9a-zA-Z-_.]*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/
    if (reg.test(value) === false || value === '') {
      alert(`${i18n.global.t('order.msg66')}\n${i18n.global.t('order.msg67')}`)
    }
  } else if(type === 'space') {
    value =  target.value
    value = value.replace(/ /g, '')
    target.value = value
  }
}

const getDateByFormat = (date, format) => {
  return moment(date).format(format)
}

const getDate = (date, format) => {
  return moment.unix(date).format(format)
}

const getIsoDates = (month) => {
  const now = new Date()
  const koreaTimezoneOffset = '+09:00'

  now.setUTCHours(0, 0, 0, 0)
  
  function substractDate(date, month) {
    const newDate = new Date(date)
    newDate.setUTCMonth(date.getUTCMonth() - month)
    return newDate
  }

  function toISO8601(date) {
    return date.toISOString().replace(/\.\d{3}Z$/, koreaTimezoneOffset)
  }

  if(month === 0) return toISO8601(now, month)
  else return toISO8601(substractDate(now, month))
 }

const getDateRange = (param) => {
  const startDate = param.startDate
  const endDate = param.endDate
  const range = moment(endDate).diff(moment(startDate), 'days')
  const dateRange = []
  for(let i = 0; i <= range; i++) {
    dateRange.push(moment(startDate).add(i, 'days').format(param.format))
  }
  return dateRange
}

const getRange = (param) => {
  var endDate = moment(new Date()).format('YYYYMMDD')
  var startDate
  if(param === 'r1') startDate = moment(new Date()).add(-29, 'days').format('YYYYMMDD')
  else if(param === 'r2') startDate = moment(new Date()).add(-89, 'days').format('YYYYMMDD')
  else if(param === 'r3') startDate = moment(new Date()).add(-179, 'days').format('YYYYMMDD')
  else if(param === 'r4') startDate = moment(new Date()).add(-364, 'days').format('YYYYMMDD')
  else startDate = moment(new Date()).add(param, 'days').format('YYYYMMDD')
  return {startDate: startDate, endDate: endDate}
}

const getUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 3 | 8)
    return v.toString(16)
  })
}

// const uploadPb = async (file, service, type) => {
//   return new Promise( (resolve, reject) => {
//       const formData = new FormData()
//       formData.append("file", file)
//       formData.append('service', service)
//       formData.append('type', type)
//       pb.collection('upload').create(formData)
//       .then(res => {
//         console.log(res)
//           const collectionId = res.collectionId 
//           const id = res.id
//           const fileName = res.file
//           // const imgUrl = pbUrl + '/api/files/' + collectionId + '/' + id + '/' + fileName 
//           // resolve(imgUrl)
//           resolve(collectionId + '/' + id + '/' + fileName)
//       })
//       .catch(err => {
//           reject("Upload failed");
//           console.error("Error:", err)
//       })
//       .finally(() => {
//           console.log(service + ' - ' + type)
//       })
//   })
// }

const deleteS3 = async (key, s3) => {
  if(key.length > 5) {
    const file = 'geek9/qna/' + key
    const params = {
      Bucket: "business-upload",
      Key: file,
    }
    try {
     s3.deleteObject(params, function(err, data) {
        if (err) {
          console.log('Error deleting file: ', err)
        } else {
          console.log('File deleted : ' + data)
        }
      })
    } catch (error) {
      console.error(error)
    }
  }
}
const contentTypeList = [
  { name: 'logistics'},
  { name: 'blog'},
  { name: 'review'},
  { name: 'market'},
  { name: 'hot'},
  { name: 'mail'},
]
const downloadS3 = async (key) => {
  const file = 'geek9/qna/' + key
  const params = {
    Bucket: "business-upload",
    Key: file,
  }
  try {
    const data = await this.s3.getObject(params).promise()
    const blob = new Blob([data.Body], { type: "image/jpeg" })
    const reader = new FileReader()
    reader.onload = () => {
      console.log(reader.result)
    }
    reader.readAsDataURL(blob)
  } catch (error) {
    console.error(error)
  }
}
const getCountryFlag = (country) => {
  if(country === '프랑스') return 'https://geek9.kr/assets/france.png'
  else if(country === '홍콩') return 'https://geek9.kr/assets/hongkong.png'
  else if(country === '스페인') return 'https://geek9.kr/assets/spain.png'
  else if(country === '이탈리아') return 'https://geek9.kr/assets/italy.png'
  else if(country === '네덜란드') return 'https://geek9.kr/assets/netherlands.png'
  else if(country === '싱가포르') return 'https://geek9.kr/assets/singapore.png'
  else if(country === '영국') return 'https://geek9.kr/assets/uk.png'
  else if(country === '독일') return 'https://geek9.kr/assets/ger.png'
  else if(country === '일본') return 'https://geek9.kr/assets/jpn.png'
  else if(country === '중국') return 'https://geek9.kr/assets/chn.png'
  else if(country === '미국') return 'https://geek9.kr/assets/usa.png'
  else if(country === '캐나다') return 'https://geek9.kr/assets/can.png'
  else if(country === '호주') return 'https://geek9.kr/assets/australia.png'
  else if(country === '오스트리아') return 'https://geek9.kr/assets/austria.png'
  else if(country === '뉴질랜드') return 'https://geek9.kr/assets/nz.png'
  else if(country === '베트남') return 'https://geek9.kr/assets/vietnam.png'
  else if(country === '대만') return 'https://geek9.kr/assets/taiwan.png'
  else if(country === '벨기에') return 'https://geek9.kr/assets/bel.png'
  else if(country === '말레이시아') return 'https://geek9.kr/assets/myr.png'
  else if(country === '인도') return 'https://geek9.kr/assets/inr.png'
  // else if(country === '태국') return 'https://geek9.kr/assets/thailand.png'
  else return 'https://geek9.kr/assets/question.png'
}
const getFirstImageSrc = (html) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  const firstImg = doc.querySelector('img')
  return firstImg ? firstImg.src : null
}
const getAllImageSrcs = (html) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  const imgElements = doc.querySelectorAll('img')
  return Array.from(imgElements).map(img => img.src)
}
const uploadS3 = async (file, fileName, s3) => {
  var params = {}
  params.Bucket = 'business-upload'
  params.Key =  'geek9/qna/'+ fileName
  params.Body = file

  await s3.putObject(params, async (err) => {
    if(err)  console.log(err,err.stack)
  })
}

const textCut = (text, length) => {
  const maxLength = length
  if(text.length > maxLength) return text.substring(0, maxLength) + '...'
  else return text
}

const getCurrency = (country) => {
  const found = (COUNTRIES || []).find(c => c.name === country)
  const currency = found ? ` ${found.currency}` : ' EUR'
  return currency
}

const axiosGql = async (type, variables) => {
  if(type === 'GET_ACCOUNT' || type === 'SELECT_COIN_JOBS' || type === 'SELECT_COIN_ORDER' || type === 'GET_CLOSED_ORDERS' || type === 'GET_ALL_MARKETS' || type === 'SELECT_ALL_MODELS' ) 
    return axiosGeek9({method: 'get', url: '/coin', params: variables})
  else if(type === 'DELETE_COIN_JOBS' || type === 'UPDATE_COIN_JOBS' || type === 'cancelCoin' || type === 'restartCoin' || type === 'INSERT_COIN_JOBS' ) 
    return axiosGeek9({method: 'post', url: '/coin', params: variables})
  else if(type === 'removeWaitingQueue' || type === 'thirty' || type === 'baseball' || type === 'updateWaitingQueue' || type === 'UPSERT_BASEBALL') 
    return axiosGeek9({method: 'post', url: '/websocket', params: variables})
  else if(type === 'SELECT_BASEBALL' || type === 'SELECT_GAME_RANK') 
    return axiosGeek9({method: 'get', url: '/websocket', params: variables})
  else if(type === 'GET_URL_ITEM_INFO' ||  type === 'SELECT_FORWARD_MAIL' || type === 'SELECT_FINANCE_BY_YEARMONTH' || type === 'SELECT_AUTOMATE' || type === 'SELECT_FINANCE_BY_YEAR' || type === 'SELECT_FINANCE' || type === 'SELECT_FINANCE_MONTHLY_STATS' || type === 'SELECT_FINANCE_CHART' || type === 'SELECT_FINANCE_SUGGESTIONS' || type === 'SELECT_FINANCE_CATEGORIES' || type === 'SELECT_FINANCE_USAGES' || type === 'SELECT_FINANCE_INSTITUTIONS' ||type === 'SELECT_IPORTER_ORDER_DTL' || type === 'SELECT_ORDER_CHART' || type === 'SELECT_NAVER_PROFILE' || type === 'SELECT_NAVER_TOKEN' || type ==='WEEK_KEYWORD' || type ==='MONTH_KEYWORD' || type ==='YEAR_KEYWORD' || type === 'store' || type === 'SELECT_GEEKTS' || type === 'SELECT_STORE_UPLOAD_BY_URL' || type === 'SELECT_STORE_UPLOAD_BY_KEYWORD' || type === 'SELECT_STORE_UPLOAD' || type === 'SELECT_STORE_CATE' || type === 'SELECT_ORDER_PRICE_DTL' || type === 'googleSheet' || type === 'SELECT_KEYWORDS' || type=== 'SELECT_BOARD' || type=== 'SELECT_BOARD_BY_KEYWORD' || type=== 'SELECT_BOARD_SUGGEST' || type=== 'SELECT_BOARD_BY_IDX' || type === 'SELECT_ORDER_IMG_URL' || type === 'SELECT_DATASET_QA' || type === 'READ_MODEL' || type === 'READ_FILE_ALL' || type === 'READ_FILE_BY_PAGE' || type === 'SELECT_ORDER_REGIST' ||  type === 'SELECT_POLICY_GRP' || type === 'vinted' || type === 'currency' || type === 'merciTotebag-detail' || type === 'merciTotebag' || type === 'SELECT_TODO' || type === 'SELECT_TRADE_BY_ID' || type === 'SELECT_WORK_MGR' || type === 'SELECT_WORK_REQUEST_HISTORY' || type === 'SELECT_WORK_WAREHOUSE' || type === 'SELECT_WORK_REQUEST' || type === 'SELECT_WORK_ESTIMATE' || type === 'SELECT_TRADE_MSG' || type === 'SELECT_TRADE' || type === 'SELECT_TRADE_BY_IDX' || type === 'SELECT_MORPHEME' || type === 'SELECT_STOPWORD' || type === 'SELECT_USERWORD' || type === 'SELECT_SENTENCE' || type === 'SELECT_DELIVERY_INFO' || type === 'SELECT_ORDER_INFO_BY_UID' || type === 'SELECT_ORDER_BY_UID' || type === 'SELECT_ORDER_INFO_BY_CONDITION' || type === 'SELECT_ORDER_INFO_LIST' || type === 'SELECT_DISTINCT_ORDER_LIST2' || type === 'SELECT_DISTINCT_ORDER_LIST' || type === 'SELECT_ETF_LIST' || type === 'SELECT_STOCK_TRADE2' || type === 'SELECT_STOCK_TRADE' || type ==='SELECT_RECENT_SELL_STOCK' || type === 'SELECT_ALL_STOCK_PROFIT' || type === 'SELECT_STOCK_BY_DATE' || type === 'SELECT_TOP_STOCK_BY_CODE' || type === 'SELECT_STOCK_BY_CODE' || type === 'SELECT_STOCK_BY_CONDITION' || type === 'SELECT_POSSESS_LIST' || type === 'SELECT_STOCK_LIST' || type === 'SELECT_MYPAGE' || type === 'SELECT_FORWARDER' || type === 'SELECT_QNA_LIST' || type === 'SELECT_QA' || type === 'SELECT_ORDER_LIST2' || type === 'SELECT_ORDER_BY_FORWARDER' || type === 'SELECT_ORDER_BY_PRICE' || type === 'SELECT_WORK_REQUEST_STATUS_CNT' || type === 'SELECT_WORK_REQUEST_STATUS' || type === 'SELECT_FORWARDER_ORDER_STATUS_CNT' || type === 'SELECT_ORDER_STATUS_CNT' || type === 'SELECT_ORDER_LIKE' || type === 'SELECT_ORDER_CART' || type === 'ADDRESS' || type === 'translate' || type === 'CAROUSELL_BY_KEYWORD' || type === 'VINTED_BY_KEYWORD' || type === 'TEMU_BY_KEYWORD' || type === 'SELECT_MOD_ORDER_HISTORY' || type === 'SELECT_SOLAIR_ORDER' || type === 'GET_CRSF' || type === 'GET_ADDR_ZIP' || type === 'SELECT_CONSUMER' || type === 'SELECT_ORDER_BY_CONDITION' || type === 'SELECT_ORDER_BY_ID2' || type === 'SELECT_COMBINE_ORDER' || type === 'SELECT_TRADE_QUESTION'|| type === 'SELECT_ORDER_STATISTIC' || type === 'SELECT_ORDER_HISTORY' || type === 'SELECT_UID_BY_NAME' || type === 'SELECT_COMPANY_ORDER' || type === 'SELECT_ITEM' || type === 'SELECT_COMPANY' || type === 'SELECT_SAMSUNG_ONLY' || type === 'SELECT_USER' || type === 'SELECT_USER_BY_TYPE' || type === 'SELECT_GAME' || type === 'SELECT_NOTICE' || type === 'SELECT_NOTICE2' || type === 'SELECT_NOTICE4' || type === 'SELECT_POINT_HISTORY' || type === 'YAHOO_SELECT_STOCK_BY_CODE' || type === 'calcBuy' || type === 'calcCorpDelivery' || type === 'calcDelivery' || type === 'VINTED' || type === 'CAROUSELL' || type === 'SHOPEE' || type === 'presPrice' || type === 'refresh' || type === 'news' || type === 'SELECT_COMMON_USER' || type === 'dau' || type === 'wau' || type === 'mau' || type === 'recentMau' || type === 'recentWau') 
    return axiosGeek9({method: 'get', url: '/geek9', params: variables})
  else if(type === 'DELETE_FINANCE_BY_CONDITION' || type === 'DELETE_FINANCE_REFUND' || type === 'UPSERT_FINANCE_PAY_PRICE' || type === 'INSERT_FINANCE' || type === 'INSERT_FINANCE' || type === 'UPDATE_FINANCE' || type === 'DELETE_FINANCE' || type === 'DELETE_FINANCE_LIST' ||type === 'IPORTER_API_TRACKING_URL' || type === 'INSERT_FORWARDER' || type === 'INSERT_CAFE_PRODUCT' || type === "INSERT_CAFE_REVIEW" || type === 'UPDATE_GEEKTS_STATUS' || type === 'UPDATE_GEEKTS_BY_LIST' || type === 'DELETE_GEEKTS_BY_LIST' || type === 'instagram' || type === 'DELETE_BOARD' || type === 'DELETE_DATASET_QA' || type === 'UPDATE_DATASET_QA' || type === 'INSERT_DATASET_QA' || type === 'EXECUTE_MODEL' || type === 'UPDATE_WORK_REQUEST_FILE_NAME' || type === 'DELETE_TODO' || type === 'DELETE_COMMON_USER' || type === 'INSERT_COMMON_USER' || type === 'UPDATE_WORK_REQUEST_STATUS' || type === 'UPDATE_WORK_MGR_STATUS' || type === 'removeImg' || type === 'DELETE_TRADE' || type === 'UPDATE_TRADE_MSG' || type === 'UPDATE_TRADE' || type === 'DELETE_TRADE_CHILD_MSG' || type === 'DELETE_TRADE_MSG' || type === 'INSERT_TRADE_MSG' || type === 'UPDATE_ORDER_MSG_CHK_YN' || type === 'UPDATE_ORDER_FILE' || type === 'DELETE_QNA' || type === 'INSERT_ORDER_INFO' || type === 'UPSERT_MYPAGE' ||  type === 'UPDATE_STOCK_TRADE' || type === 'UPDATE_POSSESS' || type === 'INSERT_USER' || type === 'INSERT_ORDER_HISTORY' || type === 'UPDATE_ORDER_BY_UID' || type === 'UPDATE_ORDER_INFO_USE_YN' || type === 'UPDATE_ORDER_USE_YN' || type === 'DELETE_STOCK_TRADE' || type === 'DELETE_ORDER_INFO_BY_UID' || type === 'DELETE_ORDER_BY_UID' || type === 'DELETE_NOTICE' || type === 'DELETE_NOTICE_BY_ID' ||  type === 'DELETE_STOCK' || type === 'INSERT_STOCK_POSSESS' || type === 'INSERT_STOCK' || type === 'INSERT_STOCK_TRADE' || type === 'INSERT_STOPWORD' || type === 'INSERT_USERWORD' || type === 'INSERT_SENTENCE' || type === 'lottoNum' || type === 'geek9.updateQna' || type === 'geek9.updateQa' || type === 'INSERT_STAT_KEYWORD' || type === 'DELETE_ORDER_CART' || type === 'DELETE_ORDER_LIKE' || type === 'INSERT_ORDER_CART' || type === 'INSERT_ORDER_LIKE' || type === 'DELETE_CHECKED_ORDER' || type === 'UPDATE_ORDER_INFO_USER' || type === 'UPDATE_ORDER_ITEM' || type === 'INSERT_QNA' || type === 'UPDATE_ITEM_STOCK' || type === 'UPDATE_ORDER_ESTIMATE' || type === 'INSERT_ITEM' || type === 'INSERT_COMPANY' || type === 'UPSERT_USER' || type === 'UPDATE_NOTICE' || type === 'INSERT_NOTICE' || type === 'UPDATE_ORDER_BY_FORWARDER' || type === 'UPDATE_ORDER_BY_IDX' || type === 'INSERT_POINT_HISTORY' || type === 'SLACK' || type === 'EXECUTE_FORCE' || type === 'UPDATE_POINT' || type === 'UPSERT_MODEL' || type === 'UPSERT_ORDER_PRICE_DTL' || type === 'DELETE_ORDER_PRICE_DTL' || type === 'INSERT_ORDER_PRICE_DTL') 
    return axiosGeek9({method: 'post', url: '/geek9', params: variables})
  else if(type === 'DELETE_IMG' || type === 'DELETE_QUOTE' || type === 'UPLOAD_ORDER_FILE' || type === 'UPLOAD_IMG' || type === 'UPLOAD_MARKET_IMGS' || type === ' ' ) 
    return axiosGeek9({method: 'post', url: '/formdata/upload', data: variables, headers: { "Content-Type": "multipart/form-data" }})
  else if(type === 'SELECT_CONSULT_HR_MGR') 
    return axiosGeek9({method: 'get', url: '/consult', params: variables})
  else if(type === 'SELECT_ORDER_STATUS_CNT2' || type === 'toMail' || type === 'INSERT_FINANCE_LIST' || type === 'UPSERT_CONTENTS_TMP' || type === 'REMOVE_FILE_CONTENT' || type === 'INSERT_TRADE' || type === 'INSERT_AUTO_CONTENT' || type === 'MODIFY_FILE_CONTENT' || type === 'WRITE_FILE' || type === 'CHATBOT_ASK' || type === 'CHATBOT_HEALTH' || type === 'CHATBOT_RESTART' || type === 'CRUZGPT_ASK' || type === 'UPDATE_MODEL' || type === 'INSERT_BOARD' || type === 'UPDATE_BOARD' || type === 'UPDATE_TODO' || type === 'INSERT_TODO' || type === 'INSERT_WORK_REQUEST_HISTORY' || type === 'DELETE_WORK_REQUEST' || type === 'DELETE_WORK_MGR' || type === 'DELETE_WORK_WAREHOUSE' || type === 'UPDATE_WORK_REQUEST' || type === 'UPDATE_WORK_WAREHOUSE' || type === 'UPDATE_WORK_MGR' || type === 'INSERT_ORDER_LIST' || type === 'INSERT_GEEKTS_LIST' || type === 'INSERT_WORK_REQUEST' || type === 'INSERT_WORK_MGR' || type === 'INSERT_WORK_ESTIMATE' || type === 'sendId')
    return axiosGeek9({method: 'post', url: '/formdata', data: variables, headers: { "Content-Type": "multipart/form-data" }})
  else if(type === 'market') 
    return axiosGeek9({method: 'get', url: '/img', params: variables})
  else if(type === 'SSR_CONTENT')
    return axiosGeek9({method: 'get', url: '/contents', params: variables})
  const res = await axios.post('/graphql', {
    headers :  {   
      'Cache-Control': ['no-cache', 'no-store', 'must-revalidate'],
      'Pragma': ['no-cache', 'no-store', 'must-revalidate'],
      'Expires': '0',
      'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true, query: type , variables: variables
  })
  return res.data.data
}

const calcNextPrice = async (stock, insertPrice) => {
  let nextBuyRate = 0.2
  let nextSellRate = 0.00
  let nextSellPrice
  let nextBuyPrice
  let broker = stock.BROKER
  let price = stock.PRICE

  if(insertPrice !== -1) price = insertPrice

  if(broker === '한국투자증권') {
    nextSellRate = 0.02
    nextSellPrice = price * (1 + nextSellRate)
    nextBuyPrice  = price * (1 - nextBuyRate)
  } else {
    nextSellRate = 0.25
    if(price >= 500000) {
      nextSellPrice = price + 50000.0
      nextBuyPrice  = price - 50000.0 
    } else if(price >= 100000) {
      nextSellPrice = price + 20000.0
      nextBuyPrice  = price - 20000.0 
    } else if(price >= 50000) {
      nextSellPrice = price + 10000.0
      nextBuyPrice  = price - 10000.0 
    } else if(price >= 10000) {
      nextSellPrice = price + 4000.0
      nextBuyPrice  = price - 4000.0
    } else if(price >= 1000 && price <=3000 ) {
      nextSellPrice = price + 1000.0
      nextBuyPrice  = price - 1000.0
    } else {
      nextSellPrice = price * (1 + nextSellRate)
      nextBuyPrice  = price * (1 - nextBuyRate)
      if(nextBuyPrice < 1000) nextBuyPrice = 500.0
      if(nextSellPrice < 1000) nextSellPrice = 2000.0    
    }
  }

  nextSellPrice = Math.round(nextSellPrice)
  nextBuyPrice = Math.round(nextBuyPrice)

  stock.NEXT_SELL_PRICE = nextSellPrice
  stock.NEXT_BUY_PRICE = nextBuyPrice

  return stock
}

const getRequestStatus = (param) => {
  if(param === -2) return '고객거절'
  else if(param === -1) return '취소'
  else if(param === 0) return '견적요청받음(고객->GEEK9)'
  else if(param === 1) return '견적요청했음(GEEK9->담당자)'
  else if(param === 2) return '견적받음(담당자->GEEK9)'
  else if(param === 3) return '견적제안완료(GEEK9->고객)'
  else if(param === 4) return '고객답변대기중'
  else if(param === 5) return '고객답변받음(고객->GEEK9)'
  else if(param === 6) return '거래성사'
  else if(param === 7) return `${i18n.global.t('menu.progress7')}`
}

const getOrderStatus = (param) => {
  if(param === -2) return `${i18n.global.t('menu.progress-2')}`
  else if(param === -1) return `${i18n.global.t('menu.progress-1')}`
  else if(param === 0) return `${i18n.global.t('menu.progress0')}`
  else if(param === 1) return `${i18n.global.t('menu.progress1')}`
  else if(param === 2) return `${i18n.global.t('menu.progress2')}`
  else if(param === 3) return `${i18n.global.t('menu.progress3')}`
  else if(param === 4) return `${i18n.global.t('menu.progress4')}`
  else if(param === 5) return `${i18n.global.t('menu.progress5')}`
  else if(param === 6) return `${i18n.global.t('menu.progress6')}`
  else if(param === 7) return `${i18n.global.t('menu.progress7')}`
  else if(param === 99) return '제외'
  else if(param === 100) return '미예약'
  else if(param === 101) return '예약'
  else if(param === 102) return '게시'
  else if(param === `${i18n.global.t('menu.progress-2')}`) return -2 
  else if(param === `${i18n.global.t('menu.progress-1')}`) return -1
  else if(param === `${i18n.global.t('menu.progress0')}`) return 0 
  else if(param === `${i18n.global.t('menu.progress1')}`) return 1
  else if(param === `${i18n.global.t('menu.progress2')}`) return 2
  else if(param === `${i18n.global.t('menu.progress3')}`) return 3
  else if(param === `${i18n.global.t('menu.progress4')}`) return 4
  else if(param === `${i18n.global.t('menu.progress5')}`) return 5
  else if(param === `${i18n.global.t('menu.progress6')}`) return 6
  else if(param === `${i18n.global.t('menu.progress7')}`) return 7
  else if(param === '제외') return 99
  else if(param === '미예약') return 100
  else if(param === '예약') return 101
  else if(param === '게시') return 102
  else return ''
}

const DELVERY_KR_COMPANY = [
  { name: 'Qxpress'},
  { name: '우체국EMS'},
  { name: 'DHL'},
  { name: 'FEDEX'},
  { name: 'UPS'},
  { name: 'Singpost'},
  { name: 'SF Express'},
  { name: 'HK POST'},
  { name: 'SPX'}
]

const getDeliveryUrl = (invoiceNumber, deliveryKrCompany) => {
  if(deliveryKrCompany === "CJ대한통운") return "https://track.shiptrack.co.kr/cjkorex/" + invoiceNumber
  if(deliveryKrCompany === "SF Express") return "https://www.sf-international.com/kr/ko/dynamic_function/waybill/#search/bill-number/" + invoiceNumber
  else if(deliveryKrCompany === "우체국") return "https://track.shiptrack.co.kr/epost/" + invoiceNumber
  else if(deliveryKrCompany === "우체국EMS") return "https://track.shiptrack.co.kr/ems/" + invoiceNumber
  else if(deliveryKrCompany === "Qxpress") return "https://smartship.qxpress.net/Customer/PopupTraceParcels?TrackingNo=" + invoiceNumber
  else if(deliveryKrCompany === "롯데택배") return "https://track.shiptrack.co.kr/lotteglogis/" + invoiceNumber
  else if(deliveryKrCompany === "HK POST") return "https://webapp.hongkongpost.hk/en/mail_tracking/index.html"
  else if(deliveryKrCompany === "한진택배") return "https://track.shiptrack.co.kr/hanjin/" + invoiceNumber
  else if(deliveryKrCompany === "로젠택배") return "https://track.shiptrack.co.kr/ilogen/" + invoiceNumber
  else if(deliveryKrCompany === "KG옐로우캡택배") return "http://www.yellowcap.co.kr/custom/inquiry_result.asp?invoice_no=" + invoiceNumber
  else if(deliveryKrCompany === "현대택배")return "http://www.hanjin.co.kr/Delivery_html/inquiry/result_waybill.jsp?wbl_num=" + invoiceNumber
  else if(deliveryKrCompany === "DHL") return "http://www.dhl.co.kr/publish/kr/ko/eshipping/track.high.html?pageToInclude=RESULTS&type=fasttrack&AWB=" + invoiceNumber
  else if(deliveryKrCompany === "FEDEX") return "https://track.shiptrack.co.kr/fedexkr/" + invoiceNumber
  else if(deliveryKrCompany === "동부익스프레스") return "http://www.dongbuexpress.co.kr/Html/Delivery/DeliveryCheckView.jsp?item_no=" + invoiceNumber
  else if(deliveryKrCompany === "KGB택배") return "http://www.kgbls.co.kr/sub5/trace.asp?f_slipno=" + invoiceNumber
  else if(deliveryKrCompany === "대신택배") return "https://track.shiptrack.co.kr/ds3211/1234" + invoiceNumber
  else if(deliveryKrCompany === "UPS") return "http://www.ups.com/WebTracking/track?loc=ko_KR&InquiryNumber1=" + invoiceNumber
  else if(deliveryKrCompany === "경동택배") return "https://track.shiptrack.co.kr/kdexp/1234" + invoiceNumber
  else if(deliveryKrCompany === "천일택배") return "https://track.shiptrack.co.kr/chunil/" + invoiceNumber
  else if(deliveryKrCompany === "이노지스택배") return "http://www.innogis.net/trace02.asp?invoice=" + invoiceNumber
  else if(deliveryKrCompany === "일양로지스택배") return "https://track.shiptrack.co.kr/ilyanglogis/" + invoiceNumber
  else if(deliveryKrCompany === "CVSnet편의점택배") return "http://was.cvsnet.co.kr/src/ctod_status.jsp?invoice_no=" + invoiceNumber
  else if(deliveryKrCompany === "한덱스") return "http://btob.sedex.co.kr/work/app/tm/tmtr01/tmtr01_s4.jsp?IC_INV_NO=" + invoiceNumber
  else if(deliveryKrCompany === "하나로택배") return "http://www.hanarologis.com/branch/chase/listbody.html?a_gb=center&a_cd=4&a_item=0&fr_slipno=" + invoiceNumber
  else if(deliveryKrCompany === "TNT") return "http://www.tnt.com/webtracker/tracking.do?respCountry=kr&respLang=ko&searchType=CON&cons=" + invoiceNumber
  else if(deliveryKrCompany === "GTX") return "http://www.gtx2010.co.kr/del_inquiry_result.html?s_gbn=1&awblno=" + invoiceNumber
  else if(deliveryKrCompany === "건영택배") return "https://track.shiptrack.co.kr/kunyoung/" + invoiceNumber
  else if(deliveryKrCompany === "HB한방택배") return "http://www.hbtb.co.kr/search/s_search.asp?f_slipno=" + invoiceNumber
  else if(deliveryKrCompany === "Singpost") return "https://www.singpost.com/track-items?trackingid=" + invoiceNumber
  else if(deliveryKrCompany === "SPX") return "https://spx.sg/track?" + invoiceNumber
  else return ''
}

const emojiRemover = (text) => {
  return emojiStrip(text).replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAB0}-\u{1FABF}\u{2B50}]/gu, '')
}

const getOs = () => {
  const userAgent = window.navigator.userAgent
  const platform = window.navigator.platform
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
  // const iosPlatforms = ['iPhone', 'iPad', 'iPod']
  let os = ''
  if (macosPlatforms.indexOf(platform) !== -1)        os = 'Mac'
  else if ('iPhone'.indexOf(platform) !== -1)         os = 'iPhone'
  else if ('iPad'.indexOf(platform) !== -1)           os = 'iPad'
  else if ('iPod'.indexOf(platform) !== -1)           os = 'iPod'
  else if (windowsPlatforms.indexOf(platform) !== -1) os = 'Windows'
  else if (/Android/.test(userAgent))                 os = 'Android'
  else if (!os && /Linux/.test(platform))             os = 'Linux'
  return os
}

const shortenUrl = (url) => {
  return url = url.split('?')[0]
}

export default {
  getUUID, deleteS3, downloadS3, uploadS3, getOs, getDateRange, getIsoDates,getDateByFormat, axiosGql, setCookies, getCookies, setPage, getRange, getDeliveryUrl, DELVERY_KR_COMPANY, getOrderStatus, getRequestStatus, emojiRemover, validate, getDate, clear_cache, calcNextPrice, BACKEND_URL, POCKETBASE_URL, WSRV_POCKETBASE_URL, SMART_STORE_URL, CAFE_STORE_URL, translate, textCut, getCurrency, getFirstImageSrc, getAllImageSrcs, getGoogleTranslateUrl, shortenUrl, copyClipboard, stripHtmlTags, getOAuthToken, CAFE_MENU_LIST, DELIVERY_COUNTRIES, BUY_COUNTRIES, ETC_COUNTRIES, REV_COUNTRIES, COUNTRIES, FINANCE_PRICE1, FINANCE_PRICE2, FINANCE_PRICE3, FINANCE_PRICE4, FINANCE_OUTCOME, FINANCE_INCOME, FORWARDER, getCateNameById, getCountryName, list2String, getCountryFlag, contentTypeList, resizeImage, requestGoogle, requestFacebook
}